import { render, staticRenderFns } from "./create.vue?vue&type=template&id=6ac75588&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=6ac75588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac75588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac75588')) {
      api.createRecord('6ac75588', component.options)
    } else {
      api.reload('6ac75588', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=6ac75588&scoped=true&", function () {
      api.rerender('6ac75588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/modifySupplement/create.vue"
export default component.exports